<template>
    <div>
        <div ref="wordCloudDiv" :style="{ height: height, width: width }">
        </div>
    </div>
</template>

<script>
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4plugins_wordCloud from "@amcharts/amcharts4/plugins/wordCloud";
    import { EventBus } from '../../event/event-bus.js';
    export default {
        name: 'WordCloudChart',
        props: {
            width: {
                default: "auto",
                type: String
            },
            height: {
                default: "450px",
                type: String
            },
            title: {
                default: "",
                type: String
            },
            data: {
                default: () => [],
                type: Array
            },
            rotation: {
                default: 0,
                type: Number
            },
            accuracy: {
                default: 4,
                type: Number
            },
            rotationThreshold: {
                default: 70,
                type: Number
            },
            step: {
                default: 15,
                type: Number
            },
            minFontSize: {
                default: 5,
                type: Number
            },
            maxFontSize: {
                default: 20,
                type: Number
            },
            colors: {
                default: function () { return ["#ddd", '#ccc'] },
                type: Array
            },
            reportFilterOverride: {
                default: () => ({
                    startDate: null,
                    endDate: null,
                    name: "",
                    selectedOperatorBrands: []
                }),
                type: Object
            },
        },
        watch: {
            deep: true,
            immediate: true,
            data() {
                this.render();
            },
            title(val) {
                this.titleObj.text = val;
                this.titleObj.fontSize = 20;
            },
            rotation(val) {
                this.series.labelsContainer.rotation = val;
            },
            rotationThreshold(val) {
                this.series.rotationThreshold = val / 100;
            },
            minFontSize(val) {
                this.series.minFontSize = am4core.percent(val);
            },
            maxFontSize(val) {
                this.series.maxFontSize = am4core.percent(val);
            },
            accuracy(val) {
                this.series.accuracy = val;
            },
            step(val) {
                this.series.step = val;
            },
            colors() {
                this.render();
            },
        },
        data: function () {
            return {
                chart: {},
                series: {},
                titleObj: {}
            }
        },
        created() {
            EventBus.$on('emit-theme-change', () => {
                this.refreshTheme();
            });

        },
        mounted() {
            this.render();
        },
        methods: {
            async render() {
                this.chart = am4core.create(this.$refs.wordCloudDiv, am4plugins_wordCloud.WordCloud);

                this.series = this.chart.series.push(new am4plugins_wordCloud.WordCloudSeries());
                this.titleObj = this.chart.titles.create();
                this.titleObj.text = this.title;
                this.titleObj.fontSize = 20;
                this.titleObj.marginBottom = 20;

                this.series.heatRules.push({
                    "target": this.series.labels.template,
                    "property": "fill",
                    "min": am4core.color("#67b7dc"),
                    "max": am4core.color("#ff9200"),
                    "dataField": "value"
                });
                this.series.randomness = 0;
                this.series.accuracy = this.accuracy;
                this.series.step = this.step;
                this.series.rotationThreshold = this.rotationThreshold / 100;
                // this.series.maxCount = 200;
                //  this.series.minWordLength = 2;
                //this.series.labels.template.margin(4, 4, 4, 4);
                // this.series.maxFontSize = am4core.percent(50);
                this.series.minFontSize = am4core.percent(this.minFontSize);
                this.series.labelsContainer.rotation = this.rotation;
                this.series.labels.template.text = "{word} ({value})";

                this.series.data = this.data;
                this.series.dataFields.word = "name";
                this.series.dataFields.value = "value";
                this.series.labels.template.tooltipText = "{word}:\n[bold]{value}[/]";

                let self = this;
                this.series.labels.template.events.on("hit", function (ev) {
                    let text = ev.target.currentText.split('(')[0].trim();
                    if (self.$route.fullPath === "/report/AlertStats" || self.$route.fullPath.includes("/alertStatDetails")) {
                        self.$router.push({ name: 'AlertStatDetails', query: { entity: text, startDate: self.reportFilterOverride.startDate, endDate: self.reportFilterOverride.endDate } });
                    } else {
                        self.$router.push({ name: 'PostSevData', query: { name: text, startDate: self.reportFilterOverride.startDate, endDate: self.reportFilterOverride.endDate } });
                    }
                });

                if (this.colors.length > 1) {
                    let colorSet = new am4core.ColorSet();
                    colorSet.reuse = true;
                    colorSet.list = this.colors.map((color) => { return am4core.color(color) });

                    this.series.colors = colorSet;
                    this.series.colors.passOptions = {}; // makes it loop
                }
                else {
                    this.series.colors = new am4core.ColorSet();
                    this.series.colors.passOptions = {}; // makes it loop
                }

                this.series.angles = [0, -90];
                this.series.fontWeight = "700"

            },
            dispose() {
                if (this.chart) {
                    this.chart.dispose();
                }
            },
            async refreshTheme() {
                await this.render();
            },
        },
        beforeDestroy() {
            this.dispose();
        }
    }
</script>
